export type SortingState = {
  fields: {
    [key: string]: 'asc' | 'desc' | null;
  };
};

export type SortingColumn = {
  id: string;
  desc: boolean;
};

const getNextSortDirection = (current: 'asc' | 'desc' | null | undefined): 'asc' | 'desc' | null => {
  const sortCycle: { [key: string]: 'asc' | 'desc' | null } = {
    'undefined': 'asc',
    'null': 'asc',
    'asc': 'desc',
    'desc': null
  };
  return sortCycle[String(current)];
};

export const updateSortingState = (
  prevState: SortingState,
  column: SortingColumn,
  dateFields: string[]
): SortingState => {
  const field = column?.id || '';
  const newFields = { ...prevState.fields };

  if (dateFields.includes(field)) {
    const nextDirection = getNextSortDirection(newFields[field]);
    if (nextDirection === null) {
      delete newFields[field];
    } else {
      newFields[field] = nextDirection;
    }
  } else {
    Object.keys(newFields).forEach(key => delete newFields[key]);
    newFields[field] = 'asc';
  }

  return { fields: newFields };
}

export const compareValues = <T,>(a: T | null | undefined, b: T | null | undefined, transform?: (val: T) => string | number): number => {
  if (a === b) return 0;
  if (a === null || a === undefined) return 1;
  if (b === null || b === undefined) return -1;
  
  const valA = transform ? transform(a) : a;
  const valB = transform ? transform(b) : b;
  return valA < valB ? -1 : valA > valB ? 1 : 0;
};

export const sortTransformers = {
  datetime: (val: string | number | Date) => new Date(val).getTime(),
  string: (val: string | number | boolean | object) => String(val).toLowerCase(),
  number: (val: string | number) => Number(val),
} as const; 